import { useFormik } from "formik";
import { IUser } from "../types";
import * as yup from "yup";
import parsePhoneNumberFromString from "libphonenumber-js";

//schema for the form
// "firstName": "string",
// "lastName": "string",
// "displayName": "string",
// "phoneNumber": "string",
// "password": "string",
// "postalCode": "string",
// "email": "string",
// "personalEmail": "string",
// "country": "string",
// "province": "string",
// "city": "string",
// "address": "string",
// "birthDate": "2025-12-09T06:54:25.912Z",
// "description": "string",
// "mfaEnforced": true,
// "mfaAllowedType": "totp", or "email" or "webauthn"
// "mfaEnrollmentGracePeriod": 1,
// "temporaryPassword": true,
// "expiresAt": 48
//profile:File

const schema = yup.object({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  displayName: yup.string().required("Display name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  phoneNumber: yup
    .string()
    .optional()
    .test("phone-number", "Invalid phone number", (value) => {
      return value
        ? parsePhoneNumberFromString(
            value.startsWith("+") ? value : `+${value}`,
          )?.isValid()
        : true;
    }),

  password: yup.string().optional(),
  postalCode: yup.string().optional(),
  personalEmail: yup.string().email("Invalid personal email").optional(),
  country: yup.string().optional(),
  province: yup.string().optional(),
  city: yup.string().optional(),
  address: yup.string().optional(),
  birthDate: yup.date().optional(),
  description: yup.string().optional(),
  profile: yup.mixed().optional(),
  temporaryPassword: yup.boolean().optional(),
  mfaEnforced: yup.boolean().optional(),
  forcedToChangePassword: yup.boolean().optional(),
  mfaAllowedType: yup.string().oneOf(["totp", "email", "webauthn"]).optional(),
  mfaEnrollmentGracePeriod: yup.number().optional(),
  //من میخوام حداقل یه ایتم با isSelected true داشته باشمl
  userOrganizations: yup
    .array()
    .min(1, "At least one organization is required")
    .test(
      "at-least-one-selected",
      "At least one organization is required",
      (value) => {
        return value?.some((item) => item.isSelected);
      },
    )
    .of(
      yup.object({
        organizationId: yup.string().required("Organization ID is required"),
        isSelected: yup.boolean().default(false),
        roleId: yup.string().when("isSelected", ([isSelected], schema) => {
          return isSelected
            ? schema.required("Role ID is required")
            : schema.notRequired();
        }),
      }),
    ),
  roleId: yup.string().required("Role ID is required"),
});

const useAddForm = () => {
  return useFormik<IUser & { roleId: string }>({
    initialValues: {
      firstName: "",
      lastName: "",
      displayName: "",
      phoneNumber: "",
      password: "",
      postalCode: "",
      email: "",
      personalEmail: "",
      country: "",
      province: "",
      city: "",
      address: "",
      birthDate: "",
      description: "",
      mfaEnforced: false,
      mfaAllowedType: "email",
      mfaEnrollmentGracePeriod: 3,
      temporaryPassword: true,
      profile: undefined,
      forcedToChangePassword: false,
      userOrganizations: [],
      roleId: "",
    },
    validationSchema: schema,
    validateOnMount: true,
    onSubmit: (values) => {
      console.log(values);
    },
  });
};

export default useAddForm;
